import { sidebarPage } from '../utils/sidebarPageLayout.js';

export class ContactUs {
    constructor(containerId) {
        this.containerId = containerId;
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        const main = `
            <div class="fg-contact-grid">
                <div class="fg-form-card">
                    <h2 class="fg-form-card__title">Send us a Message</h2>
                    <form id="fg-contact-form">
                        <div class="fg-field">
                            <label for="fg-contact-dept">Department</label>
                            <select id="fg-contact-dept" class="fg-select" required>
                                <option value="">Select department</option>
                                <option value="editorial">Editorial</option>
                                <option value="partnerships">Partnerships</option>
                                <option value="press">Press</option>
                                <option value="technical">Technical Support</option>
                                <option value="social">Social Media</option>
                                <option value="web">Web Team</option>
                                <option value="app">App Team</option>
                                <option value="events">Events</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        <div class="fg-field">
                            <label for="fg-contact-name">Full Name</label>
                            <input type="text" id="fg-contact-name" class="fg-input" placeholder="Your full name" required>
                        </div>
                        <div class="fg-field">
                            <label for="fg-contact-email">Email Address</label>
                            <input type="email" id="fg-contact-email" class="fg-input" placeholder="your.email@example.com" required>
                        </div>
                        <div class="fg-field">
                            <label for="fg-contact-msg">Message</label>
                            <textarea id="fg-contact-msg" class="fg-textarea" placeholder="Tell us how we can help you..." required></textarea>
                        </div>
                        <div id="fg-contact-warning" class="fg-form-warning">All fields must be filled before sending your message.</div>
                        <button type="submit" class="fg-btn fg-btn--primary" id="fg-contact-submit">Send Message</button>
                        <div id="fg-contact-success" class="fg-success-panel">
                            <h3>Message Sent Successfully!</h3>
                            <p id="fg-contact-sent-email"></p>
                            <p>Please check for a response in 24 hours.</p>
                            <p>Thank you for contacting us.</p>
                            <div class="fg-brand-line">
                                <span class="fg-brand-football">football</span><span class="fg-brand-girl">girl</span><sup>™</sup><br>
                                The Home of Female Football
                            </div>
                        </div>
                    </form>
                </div>
                <aside class="fg-info-panel">
                    <h2 class="fg-info-panel__title">Get in Touch</h2>
                    <div class="fg-info-row">
                        <span class="fg-info-row__icon" aria-hidden="true">📧</span>
                        <div>
                            <h4>General Email</h4>
                            <p>admin@footballgirl.eu</p>
                        </div>
                    </div>
                    <div class="fg-info-row">
                        <span class="fg-info-row__icon" aria-hidden="true">🌐</span>
                        <div>
                            <h4>Web Issues</h4>
                            <p>web@footballgirl.eu</p>
                        </div>
                    </div>
                    <div class="fg-info-row">
                        <span class="fg-info-row__icon" aria-hidden="true">📱</span>
                        <div>
                            <h4>App Issues</h4>
                            <p>app@footballgirl.eu</p>
                        </div>
                    </div>
                    <div class="fg-info-row">
                        <span class="fg-info-row__icon" aria-hidden="true">📍</span>
                        <div>
                            <h4>Paris Office</h4>
                            <p>Regus Paris Haussmann<br>18 Rue Pasquier<br>75008 Paris, France</p>
                        </div>
                    </div>
                    <div class="fg-info-row">
                        <span class="fg-info-row__icon" aria-hidden="true">⏰</span>
                        <div>
                            <h4>Business Hours</h4>
                            <p>Monday - Friday: 9:00 AM - 6:00 PM<br>Saturday &amp; Sunday: Closed</p>
                        </div>
                    </div>
                    <div class="fg-social">
                        <h4>Follow Us</h4>
                        <div class="fg-social__icons">
                            <button type="button" class="fg-social__icon" data-social="twitter" aria-label="Twitter">🐦</button>
                            <button type="button" class="fg-social__icon" data-social="instagram" aria-label="Instagram">📷</button>
                            <button type="button" class="fg-social__icon" data-social="facebook" aria-label="Facebook">📘</button>
                            <button type="button" class="fg-social__icon" data-social="linkedin" aria-label="LinkedIn">💼</button>
                        </div>
                    </div>
                </aside>
            </div>
        `;

        el.innerHTML = sidebarPage({
            title: 'Contact Us',
            subtitle: 'Get in touch with the FootballGirl team',
            main,
            wide: true
        });

        this._attachHandlers(el);
    }

    _attachHandlers(root) {
        const form = root.querySelector('#fg-contact-form');
        const warning = root.querySelector('#fg-contact-warning');
        const success = root.querySelector('#fg-contact-success');
        const submitBtn = root.querySelector('#fg-contact-submit');
        const sentEmail = root.querySelector('#fg-contact-sent-email');

        form?.addEventListener('submit', (e) => {
            e.preventDefault();
            const dept = root.querySelector('#fg-contact-dept')?.value.trim();
            const name = root.querySelector('#fg-contact-name')?.value.trim();
            const email = root.querySelector('#fg-contact-email')?.value.trim();
            const msg = root.querySelector('#fg-contact-msg')?.value.trim();

            if (!dept || !name || !email || !msg) {
                warning?.classList.add('is-visible');
                return;
            }
            warning?.classList.remove('is-visible');

            submitBtn.textContent = 'Message Sent!';
            submitBtn.disabled = true;
            if (sentEmail) sentEmail.textContent = `A message was sent to ${email}`;
            success?.classList.add('is-visible');
            form.style.display = 'none';
        });

        root.querySelectorAll('[data-social]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const platform = btn.getAttribute('data-social') || '';
                window.alert(`${platform.charAt(0).toUpperCase() + platform.slice(1)} page coming soon!`);
            });
        });
    }
}
